import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './design-tests.component.html',
    styleUrls: ['./design-tests.component.scss'],
    standalone: false
})
export class DesignTestsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
